import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/index.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox",
    staticClass: "event-vb",
    attrs: {
      "body-padding-bottom": 0
    }
  }, [_c('div', {
    staticClass: "search-body"
  }, [_c('search', {
    ref: "search",
    attrs: {
      "placeholder": i18n.tc("395"),
      "position": "absolute",
      "auto-scroll-to-top": ""
    },
    on: {
      "on-submit": function ($event) {
        _vm.loadList(true, 'search'), _vm.$refs.search && _vm.$refs.search.setBlur && _vm.$refs.search.setBlur();
      },
      "on-cancel": function ($event) {
        ;
        _vm.searchForm.keyword = '', _vm.loadList(true, 'search');
      }
    },
    model: {
      value: _vm.searchForm.keyword,
      callback: function ($$v) {
        _vm.$set(_vm.searchForm, "keyword", $$v);
      },
      expression: "searchForm.keyword"
    }
  })], 1), _c(__unplugin_components_0, {
    ref: "orderList",
    attrs: {
      "is-px": "",
      "checked": "",
      "height": _vm.scrollerHight
    },
    on: {
      "on-pulldown-loading": _vm.onPulldownLoading,
      "on-pullup-loading": _vm.onPullupLoading
    }
  }, _vm._l(_vm.orderList, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "flex-item order-item card",
      on: {
        "click": function ($event) {
          return _vm.$router.push({
            name: 'RepairRecordDetail',
            query: {
              orderId: item.id
            }
          });
        }
      }
    }, [_c('div', {
      staticClass: "flex-column",
      staticStyle: {
        "background": "#fff"
      }
    }, [_c('div', {
      staticClass: "header"
    }, [_c('div', {
      staticClass: "font-size-h3-large smy__text-overflow-one-line title"
    }, [_c('div', {
      staticClass: "content smy__text-overflow-one-line"
    }, [_c('span', [_vm._v(_vm._s(item.send_revised_order_no))])]), _c('div', {
      staticClass: "fh-state"
    }, [_c('span', {
      style: "color:" + _vm.getStateInfo(item).color
    }, [_vm._v(_vm._s(_vm.getStateInfo(item).name))])])])]), _c('div', {
      staticClass: "content font-size-h4-large"
    }, [_c('img', {
      attrs: {
        "src": _vm.replaceMultiImg(item.img_url || '/spa_static_mobile/icon/spare120_120@3x.png'),
        "alt": ""
      }
    }), _c('div', {
      staticClass: "content-info"
    }, [_c('div', {
      staticClass: "mt6 smy__text-overflow-one-line"
    }, [_c('span', [_vm._v(_vm._s(item.sendProList[0] && item.sendProList[0].productionName))])]), _c('div', {
      staticClass: "mt6 smy__text-overflow-one-line"
    }, [_c('span', [_vm._v(i18n.tc("227") + _vm._s(item.sendProList[0] && item.sendProList[0].production_sn_uncheck))])])]), _c('div', {
      staticClass: "content-all-num"
    }, [_vm._v(i18n.tc("396") + _vm._s(item.sendCount) + i18n.tc("397"))])])])]);
  }), 0)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };